/**
 * Created by razial on 18.07.2023
 */

const UnitComponent = function (unit) {
    this.unit = unit;
};

UnitComponent.prototype.setView = function (view) {
    this.view = view;
};

UnitComponent.prototype.removeView = function () {
    this.view = undefined;
};

UnitComponent.prototype.isMovable = function () {
    return true;
};

UnitComponent.prototype.isMergeable = function () {
    return true;
};

UnitComponent.prototype.isAffectedUnit = function () {
    return false;
};

UnitComponent.prototype.onWrongTarget = function () {};

UnitComponent.prototype.findAffectedUnit = function (rawX, rawY, silent) {
    const x = Math.round(rawX);
    const y = Math.round(rawY);

    const cellsInRadius = [{ x, y }];
    const threshold = 0.15;

    const diffX = rawX - x;
    if (Math.abs(diffX) > threshold) {
        cellsInRadius.push(diffX > 0 ? { x: x + 1, y } : { x: x - 1, y });
    }

    const diffY = rawY - y;
    if (Math.abs(diffY) > threshold) {
        cellsInRadius.push(diffY > 0 ? { x, y: y + 1 } : { x, y: y - 1 });
    }

    if (Math.abs(diffX) > threshold && Math.abs(diffY) > threshold) {
        const cellX = diffX > 0 ? x + 1 : x - 1;
        const cellY = diffY > 0 ? y + 1 : y - 1;

        cellsInRadius.push({ x: cellX, y: cellY });
    }

    let isWrongTarget;
    for (let i = 0; i < cellsInRadius.length; i++) {
        const cell = cellsInRadius[i];
        const unit = Merge2.current.field.getUnit(cell.x, cell.y);

        if (unit && unit !== this.unit) {
            if (this.isAffectedUnit(unit)) {
                return unit;
            }
            isWrongTarget = true;
        }
    }

    if (isWrongTarget && !silent) {
        this.onWrongTarget();
    }
};

UnitComponent.prototype.clearAnimations = function () {
    if (this.view && this.view.clearAnimations) {
        this.view.clearAnimations();
    }
};
